import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ExcelViewerService } from '../../service/excel-viewer.service';
import { RepoApiService } from '../../service/repo-api.service';
import { ReportService } from '../../service/report.service';
import { ToplineService } from '../../service/topline.service';

@Component({
  selector: 'app-merge-topline',
  templateUrl: './merge-topline.component.html',
  styleUrls: ['./merge-topline.component.scss']
})
export class MergeToplineComponent implements OnInit {
  public studyWiseFileContainer:any[] = [];
  public selectedFile:{} = {};
  public selectTabSheetIndex:number;
  public selectTabSheeContainer:any[] = [];
  public selectedTopCut:any[] = [];
  public sheetWiseTopCutContainer:any[] = [];
  public currentClickSheetName:string = "";
  public switchingTapSheetError:string = "";
  public backFileOpenSheet:string = "";
  public autoSelectedSheet:boolean = false;
  public currentClickSheetObject:{} = {};
  public originalbackFileOpenSheet:string="";
  public AllowParentSelection:boolean = false;
  constructor(
    public eService:ExcelViewerService,
    public repoService:RepoApiService,
    public toplineService:ToplineService,
    public notifier:NotifierService,
    public reportService:ReportService

  ) { }



  ngOnInit(): void {
    this.selectTabSheetIndex = this.eService.currentOpeningSheetIndex;
    this.backFileOpenSheet = this.eService.allSheetsName[this.selectTabSheetIndex];
    this.originalbackFileOpenSheet = this.eService.allSheetsName[this.selectTabSheetIndex];
    this.getDataTableList();
    // this.eService.isMergeFileContainAllSheets = true;
  }

  ngOnDestroy(): void {
    this.resetVariable();
  }

  getDataTableList(){
    this.repoService.getDataTablesList(this.toplineService.excelviewer_fileUUID).subscribe((res) =>{
      if(res['status'] == 1){
        this.studyWiseFileContainer = res['result'].map((va:any) =>{
          return {id:va.id,name:va.name,children:va.files}
        })
        this.studyWiseFileContainer = this.process(this.studyWiseFileContainer);
      }else{
        this.notifier.notify("error","Something went wrong!")
      }
    })

  }

  private process(data): any {
    let result = [];
    result = data.map((item) => {
      return this.toTreeNode(item);
    });
    return result;
  }

  private toTreeNode(node, parent = null) {
    if(node && node.children) {
      node.children.map(item => {
        return this.toTreeNode(item, node);
      });
    }
    
    return node;
  }

  closeMergeTopline(){
    this.eService.isMergeToplineComponent = false;
  }

  selectionFileChange(event:any){
    // let staticFileId = '21fddac8-08aa-4ae6-aff3-b224f5e63ed5'
    // this.eService.getFilterOptionsForMerge(staticFileId);
    this.eService.getFilterOptionsForMerge(this.selectedFile['id']);
    this.resetVariable();
  }

  resetVariable(){
    this.selectTabSheeContainer = [];
    this.selectedTopCut= [];
    this.sheetWiseTopCutContainer = [];
    this.currentClickSheetName = "";
    this.switchingTapSheetError = "";
    this.autoSelectedSheet = false;
    this.currentClickSheetObject = {};
    
    // public backFileOpenSheet:string = "";
  }

  getMargeToSheetName(sheet_name){
    let isSheetNameFound = false;
    this.eService.allSheetsName.forEach((sheetUUID, index) =>{
      if (this.eService.allFilters[sheetUUID] && this.eService.allFilters[sheetUUID]["sheet_name"] == sheet_name) {
        this.backFileOpenSheet = sheetUUID;
        isSheetNameFound = true;
      }else if(!isSheetNameFound && index == this.eService.allSheetsName.length - 1){
        this.backFileOpenSheet = this.originalbackFileOpenSheet;
      }
    })
  }

  setSelectedTabIndex(sheet:string,sheetDetails:any,event:any){
    event.stopPropagation();
    let ele = this.selectTabSheeContainer.findIndex((va:any) => va === sheet);
    this.getMargeToSheetName(sheetDetails.sheet_name);

    if(ele === -1){
      // let obj = {sheetName:sheet,topCut:[],sheet:''};
      // this.backFileOpenSheet = this.originalbackFileOpenSheet;
      // this.currentClickSheetObject = {sheetName:this.eService.allFiltersForMerge[sheet]['sheet_name'],sheetUUID:sheet,topCut:[],sheet:this.eService.isMergeFileContainAllSheets ? this.getSheetName(sheet.toLowerCase()):this.backFileOpenSheet};
      this.currentClickSheetObject = {
                                      sheetName:this.eService.allFiltersForMerge[sheet]['sheet_name'],
                                      sheetUUID:sheet,topCut:[],
                                      sheet:this.getSheetName(this.eService.allFiltersForMerge[sheet]['sheet_name'].toLowerCase()) != "" ? this.getSheetName(this.eService.allFiltersForMerge[sheet]['sheet_name'].toLowerCase()):this.backFileOpenSheet};
      this.currentClickSheetName = sheet;
      this.selectTabSheeContainer.push(sheet);
      this.sheetWiseTopCutContainer.push(this.currentClickSheetObject);
      this.getTopCutBasedOnSelectedSheetForMerge(sheet,this.currentClickSheetObject);
    }else{
      this.currentClickSheetName = sheet
      let obj = this.sheetWiseTopCutContainer.find((va:any) => va['sheetUUID'] === this.currentClickSheetName);
      // let obj = this.sheetWiseTopCutContainer.find((va:any) => va['sheetName'] === this.currentClickSheetName);
      this.currentClickSheetObject = obj;
      this.getTopCutBasedOnSelectedSheetForMerge(obj['sheetUUID'],obj);
    }
  }

  isValidateToTapSheet(){
    if(this.sheetWiseTopCutContainer.length === 0){
      return true
    }else{
      let valid = true;
      this.sheetWiseTopCutContainer.forEach((va:any) =>{
        if(va['topCut'] && va['topCut'].length === 0){
          this.switchingTapSheetError = `Please select the topCut for ${va['sheetName']}`;
          valid = false;
        }
      })
      return valid;
    }
  }

  checkSelectedTab(sheet){
    return this.selectTabSheeContainer.find((va:any) => va === sheet);
  }

  getTopCutBasedOnSelectedSheetForMerge(sheet:string,obj:any){
    let currentSelectedSheetName = this.eService.allSheetsNameForMerge.find((va:any) => va === sheet);
    this.eService.getTopCutBasedOnSelectedSheetForMerge(currentSelectedSheetName);
    this.selectedTopCut = obj['topCut'];
    this.backFileOpenSheet = obj['sheet'];
  }


  setSelectedTopCut(event:any){
    let obj = this.sheetWiseTopCutContainer.find((va:any) => va['sheetUUID'] === this.currentClickSheetName);
    if(obj){
      obj['topCut'] = this.selectedTopCut;
    }
  }

  onSave(){
    if(this.autoSelectedSheet){
      this.setPayload(true);
    }else{
      if(this.isValidateForm()){
        this.setPayload();
      }else{
        this.notifier.notify('error',this.switchingTapSheetError);
      }
    }
  }

  setPayload(isAutoSelect?){
    // let backFileOpenSheetId = this.eService.allFilters[this.backFileOpenSheet]['sheet_id'];
    let payload = [];
    // console.log("this.sheetWiseTopCutContainer ===> ",this.sheetWiseTopCutContainer )
    // console.log("this.eService.allFilters ===> ",this.eService.allFilters )
    this.sheetWiseTopCutContainer.forEach((va:any) =>{
      let obj = {};
      obj['merge_sheet_id'] = this.eService.allFiltersForMerge[va.sheetUUID]['sheet_id'];
      obj['sheets'] = [];
      if(va.sheet && va.sheet != ""){
        obj['sheets'].push(this.eService.allFilters[va.sheet]['sheet_id']);
      }else{
        obj['sheets'] = [];
      }
      if(isAutoSelect){
        obj['filter'] = va['filters'];
      }else{
        obj['filter'] = this.eService.getTreeFormat(va['topCut'],'topcut','level')
      }
      payload.push(obj);
    })
    let body = {};
    body['payload'] = payload;
    body['file_id'] = this.toplineService.excelviewer_fileUUID;
    body['merge_file_id'] = this.selectedFile['id'];
    // console.log("body i ===>",body);
    this.eService.setPayloadForKpiMerge(body);
  }

  isValidateForm(){
    if(!Object.keys(this.selectedFile).length){
      this.switchingTapSheetError = 'Please select file for merge';
      return false;
    }
    if(this.sheetWiseTopCutContainer.length == 0){
      this.switchingTapSheetError = 'Please select sheet of merging file';
      return false;
    }else{
      return this.isValidateToTapSheet();
    }
  }

  checkSeletedFile(){
    if(Object.keys(this.selectedFile).length){
      return true;
    }
    return false;
  }

   getSelectedParent(topcuts, selectedTopcutOption){
    let parents = [];
    selectedTopcutOption.forEach(option => {
      parents.push(option.p)
    });
    parents = parents.filter(
      (element, i) => i === parents.indexOf(element)
    )
    return parents;
  }

  setSelectedTabIndexBackOpenFile(ind:number){
    this.selectTabSheetIndex = ind;
  }


  setAutoSelectedSheet($event){
    this.autoSelectedSheet = !this.autoSelectedSheet;
    if(this.autoSelectedSheet){
      this.selectTabSheeContainer = [];
      this.sheetWiseTopCutContainer = [];
      this.selectTabSheeContainer = this.eService.allSheetsNameForMerge;
      this.selectTabSheeContainer.forEach((sheet) =>{
        let obj = {};
        obj['sheetName'] = this.eService.allFiltersForMerge[sheet]['sheet_name'];
        obj['sheetUUID'] = sheet;
        obj['sheet'] = this.getSheetName(obj['sheetName'].toLowerCase())
        
        // if(this.eService.isMergeFileContainAllSheets){
        //   obj['sheet'] = this.getSheetName(sheet.toLowerCase())
        //   // obj['sheet'] = this.getSheetName(this.eService.allFiltersForMerge[sheet]['sheet_name'].toLowerCase())
        // }else{
        //   obj['sheet'] = this.originalbackFileOpenSheet;
        //   // obj['sheet'] = this.eService.allFilters[this.originalbackFileOpenSheet]['sheet_name'];
        // }
        obj['filters'] = this.eService.allFiltersForMerge[sheet]['filters'];
        this.sheetWiseTopCutContainer.push(obj);
      })
    }else{
      this.selectTabSheeContainer = [];
      this.sheetWiseTopCutContainer = [];
    }
  }

  getSheetName(sheet:string){
    // let sheet_Details = this.eService.allSheetsName.find((va:string) => (va.toLowerCase() === sheet));
    let backFileSheetKey = "";
    let isSheetNameMachedWithBackFile = "";
    isSheetNameMachedWithBackFile = this.eService.all_Sheet_Name_only.find((va:string) => (va.toLowerCase() === sheet));
    if(isSheetNameMachedWithBackFile && isSheetNameMachedWithBackFile !="") {
      this.eService.allSheetsName.forEach(sheetKey => {
        if (this.eService.allFilters[sheetKey]['sheet_name'].toLowerCase() == sheet) {
          backFileSheetKey = sheetKey;
        }
      });
    }
    return backFileSheetKey ? backFileSheetKey :'';
  }

  unSelectSelectedTab(sheet:string,event:any){
    event.stopPropagation();
    if(!this.autoSelectedSheet){
      let sheet_index = this.selectTabSheeContainer.findIndex((sht:string) => sht === sheet);
      if(sheet_index >= 0){
        this.selectTabSheeContainer.splice(sheet_index,1);
        let topcut_index = this.sheetWiseTopCutContainer.findIndex((sht:any) => sht['sheetUUID'] === sheet);
        // let topcut_index = this.sheetWiseTopCutContainer.findIndex((sht:any) => sht['sheetName'] === sheet);
        if(topcut_index >= 0){
          this.sheetWiseTopCutContainer.splice(topcut_index,1);
          // console.log("this.sheetWiseTopCutContainer ==>",this.sheetWiseTopCutContainer)
          if (this.selectTabSheeContainer && this.selectTabSheeContainer.length) {
            let sheetDetails = this.eService.allFiltersForMerge[this.selectTabSheeContainer[this.selectTabSheeContainer.length - 1]];
            this.getMargeToSheetName(sheetDetails.sheet_name)
          }else{
            this.backFileOpenSheet = this.originalbackFileOpenSheet;
          }
          this.selectedTopCut = [];
        }
      }
    }
  }

  updatetoMergeSheet(){
    this.currentClickSheetObject['sheet'] = this.backFileOpenSheet;
  }
}
